import React from "react";

const ExitReason = ({ newEmployee, setNewEmployee, exitReasons }) => {
  return (
    <>
      {/* Last Working Day (Date Picker) */}
      <div className="col-md-4 mb-3">
        <label>Last Working Day</label>
        <input
          type="date"
          className="form-control"
          value={newEmployee.last_working_day || ""}
          onChange={(e) =>
            setNewEmployee({ ...newEmployee, last_working_day: e.target.value })
          }
        />
      </div>

      {/* Exit Reason Dropdown */}
      <div className="col-md-4 mb-3">
        <label>Exit Reason</label>
        <select
          className="form-select"
          value={newEmployee.exit_reason_id ?? ""}
          onChange={(e) =>
            setNewEmployee({
              ...newEmployee,
              exit_reason_id: e.target.value ? Number(e.target.value) : null,
            })
          }
        >
          <option value="" disabled>
            Select Exit Reason
          </option>
          {exitReasons.map((reason) => (
            <option key={reason.exit_reason_id} value={reason.exit_reason_id}>
              {reason.reason_text}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default ExitReason;
